var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    width: 28.0088,
    height: 28.0088,
    rx: 5.39929,
    fill: "#ECEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27647 13.2269C8.84782 13.2269 8.50033 13.5744 8.50033 14.003C8.50033 14.4317 8.84782 14.7792 9.27647 14.7792H20.0751C20.5037 14.7792 20.8512 14.4317 20.8512 14.003C20.8512 13.5744 20.5037 13.2269 20.0751 13.2269H9.27647Z",
    fill: "#3E63FF",
    stroke: "#3E63FF",
    strokeWidth: 0.202474,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleMinus);
export default __webpack_public_path__ + "static/media/rectangle-minus.2806023fb2277eeba60e277230dea865.svg";
export { ForwardRef as ReactComponent };